import {checkbox, CheckboxField, comp, Component, fieldset, h3, Notifier, p, router} from "@intermesh/goui";
import {t} from "./util/Translate.js";
import {CurrentParticipant} from "./services/CurrentParticipant.js";
import {ServerApi} from "./util/ServerApi.js";
import {frontendParticipantDS} from "./DataSources";

export class UnsubscribeReminders extends Component {
	constructor(participantId: string) {
		super("section");

		this.itemId = "unsubscribe-reminders";
		this.id = "unsubsncribe-reminders";
		this.cls = "ifw-card";

		frontendParticipantDS.single(participantId)
			.then(async (participantData) => {
				if(!participantData) {
					Notifier.warning(t("Could not get participant"),5000);
					await router.goto("");
					return;
				}
				sessionStorage.setItem(CurrentParticipant.storageItem, JSON.stringify(participantData.data));
				const cp = CurrentParticipant.get();
				const f = fieldset({},
					comp({cls: "ifw-title-cnt"},
						h3({cls: "ifw-title", text: t("Reminder settings")})
					),
					comp({cls: "vbox"},
						p({text: `${t("Welcome")} ${cp.fullName}`}),
						p({html: t("You can select if you want to receive reminders about courses that expire.")})
					),
					checkbox({
						label: t("Reminders"),
						name: "remindMe",
						type: "switch",
						value: cp.remindMe,
						listeners: {
							change: ({newValue}) => {
								let route = "elearning/frontend/participants/" + cp.id,
									body = {
										remindMe: newValue
									};
								ServerApi.call(route, body, "PUT").then(async (result) => {
									await CurrentParticipant.refresh(result);
									Notifier.success(t("Saved successfully"), 5000);
								});
							}
						}
					}),
				);
				this.items.add(f);
			});
	}

}